import {
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  Input,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
const Offers = () => {
  const [offerName, setOfferName] = useState("");
  const [offerType, setOfferType] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState("");

  const [purchase, setPurchase] = useState("");
  const [freeProductCount, setFreeProductCount] = useState("");
  const [productImage, setProductImage] = useState(null);
  //   const { products } = useContext(ApiContext);

  //   const [getProduct, setGetProduct] = useState("");
  const disId = localStorage.getItem("id");

  const getProducts = async () => {
    try {
      const response = await axios.get(`http://api.meddaily.in/get_product`, {
        headers: {
          token: sessionStorage.getItem("token"),
        },
      });
      if (response.status === 200) {
        setSelectedProduct(response?.data?.product || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (offerName === "") {
      alert("Offer name is required");
      return;
    }

    if (offerType === "") {
      alert("Offer type is required");
      return;
    }

    if (selectedProduct === "") {
      alert("Please select a product");
      return;
    }

    if (purchase === "") {
      alert("Purchase value is required");
      return;
    }

    if (freeProductCount === "") {
      alert("Free product count is required");
      return;
    }

    if (productImage === null) {
      alert("Product image is required");
      return;
    }

    // Create a FormData object to send the file
    const formData = new FormData();
    formData.append("name", offerName);
    formData.append("image", productImage);
    formData.append("type", offerType);
    formData.append("product_id", selectedProduct);
    formData.append("distributor_id", disId);
    formData.append("product_name", "");
    formData.append("activation_value", purchase);

    try {
      const response = await fetch("http://api.meddaily.in/addoffer", {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        alert("Offer created successfully");
        // console.log("Offer created successfully",response);
        setOfferName("");
        setOfferType("");
        setSelectedProduct([]);
        setPurchase("");
        setFreeProductCount("");
        setProductImage(null);
      } else {
        console.error("Failed to create offer");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
            </Grid>
            <Grid item xs={11}>
              <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ marginTop: "15px" }}
              >
                Create Offers
              </Typography>
            </Grid>
            {/* start */}
            <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="offerName"
                    label="Offer Name"
                    variant="outlined"
                    value={offerName}
                    onChange={(e) => setOfferName(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="offerType-label">Offer Type</InputLabel>
                    <Select
                      labelId="offerType-label"
                      id="offerType"
                      value={offerType}
                      onChange={(e) => setOfferType(e.target.value)}
                      label="Offer Type"
                    >
                      <MenuItem value="">
                        <em>Select offer type</em>
                      </MenuItem>
                      <MenuItem value="discount">Discount</MenuItem>
                      <MenuItem value="bonus quantity">Bonus Quantity</MenuItem>
                    </Select>
                    <FormHelperText>Choose the type of offer</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="select-label">Select a product</InputLabel>
                    <Select
                      labelId="select-label"
                      id="selectproduct"
                      value={selectedProductName} // Use a single selectedProductName instead of an array
                      onChange={(e) => setSelectedProductName(e.target.value)} // Update the selectedProductName directly
                      label="Select a product"
                    >
                      <MenuItem value="">
                        <em>Select a product</em>
                      </MenuItem>
                      {selectedProduct.map((product) => (
                        <MenuItem key={product.id} value={product.name}>
                          {product.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      Choose a product from the list
                    </FormHelperText>
                  </FormControl>

                  {/* <FormControl fullWidth variant="outlined">
                    <InputLabel id="selectedProduct-label"></InputLabel>
                    <Select
                      labelId="selectedProduct-label"
                      id="selectedProduct"
                      value={selectedProduct}
                      onChange={(e) => setSelectedProduct(e.target.value)}
                      label="Select a Product"
                    >
                      <MenuItem value="">
                        <em>Select a product</em>
                      </MenuItem>
                      {Array.isArray(selectedProduct) &&
                        selectedProduct.map((product) => (
                          <MenuItem key={product.id} value={product.name}>
                            {product.name}
                          </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>
                      Choose a product from the list
                    </FormHelperText>
                  </FormControl> */}
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="purchase"
                    label="Purchase"
                    variant="outlined"
                    value={purchase}
                    onChange={(e) => setPurchase(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    id="freeProductCount"
                    label="Free Product Count"
                    variant="outlined"
                    value={freeProductCount}
                    onChange={(e) => setFreeProductCount(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth variant="outlined">
                    <FormGroup>
                      <Typography variant="subtitle1">
                        Upload Product Image:
                      </Typography>
                      <Input
                        type="file"
                        accept=".jpg,.png,.jpeg"
                        onChange={(e) => setProductImage(e.target.files[0])}
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: "15px" }}
                >
                  <button type="submit" className="continue1">
                    Create
                  </button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Offers;
